import Vue from 'vue';
import VueRouter from 'vue-router';
import { authGuard } from '@/auth/authGuard';
import { getInstance } from '@/auth';

Vue.use(VueRouter);

import Home from '../views/Home/Home.vue';
import HomeVideoModal from '../views/HomeVideoModal/HomeVideoModal.vue';
import HomeFoundationalReportModal from '../views/HomeFoundationalReportModal/HomeFoundationalReportModal.vue';
import PageNotFound from '../views/404.vue';
import Glossary from '../views/Glossary/Glossary.vue';
import Faq from '../views/Faq.vue';
import { globalState } from '@/stores/globalState';

const routes = [
  {
    path: '/glossary',
    name: 'Glossary',
    component: Glossary,
    beforeEnter: authGuard,
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    beforeEnter: authGuard,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: authGuard,
    children: [
      {
        name: 'Home | Video Modal',
        path: '/video/:id',
        component: HomeVideoModal,
        props: true,
      },
      {
        name: 'Home | Foundational Report Modal',
        path: '/foundational-report/:id',
        component: HomeFoundationalReportModal,
        props: true,
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    if (to.hash) {
      return { selector: to.hash, offset: { y: 60, x: 0 } };
    }

    if (to.name?.includes('Home |') || from.name?.includes('Home |')) {
      const el = document.querySelector('html');
      return { x: el?.scrollLeft || 0, y: el?.scrollTop || 0 };
    }

    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  globalState.pageLoading = { loading: true, path: to.path };
  next();
});

router.afterEach(async (to, from) => {
  const auth = getInstance();
  const user = await auth.getUser();
  if (auth.isAuthenticated && user.id) {
    // Reduce duplicate tracking for page views & removes tracking for modals
    if (
      from.name !== to.name &&
      !to.name?.includes('Modal') &&
      !from.name?.includes(to.name || '')
    ) {
      window.analytics.page(to.name);
    }
  }
  globalState.pageLoading = { ...globalState.pageLoading, loading: false };
});

export default router;
